import { Box, BoxProps, Button, ButtonGroup, Collapse, Divider, HStack, IconButton, Input, useDisclosure } from "@chakra-ui/react";
import { useRef, useState } from "react";
import { FaCalendarAlt } from "react-icons/fa";
import { MdClear } from "react-icons/md";
import { useSearchParams } from "react-router";
import { formatDate, toSqlDate } from "./utils";


export function useAffairFilter() {
    const [searchParams, setSearchParams] = useSearchParams();
    const show = useDisclosure();

    const readUrlDate = (name: string) => {
        const urlSqlStr = searchParams.get(name);
        console.log('urlSqlStr', urlSqlStr);
        if (!urlSqlStr)
            return;
        const date = new Date(urlSqlStr);
        if (isNaN(date.getTime()))
            return;
        return date;
    }

    const [fromDate, _setFromDate] = useState<Date | undefined>(() => readUrlDate('fromDate'));
    const setFromDate = (d: Date | undefined) => {
        _setFromDate(d);
        setSearchParams(prev => {
            if (d)
                prev.set('fromDate', toSqlDate(d));
            else 
                prev.delete('fromDate');
            return prev;
        });
    }
    const [toDate, _setToDate] = useState<Date | undefined>(() => readUrlDate('toDate'));
    const setToDate = (d: Date | undefined) => {
        _setToDate(d);
        setSearchParams(prev => {
            if (d)
                prev.set('toDate', toSqlDate(d));
            else 
                prev.delete('toDate');
            return prev;
        });
    }


    return {
        isOpen: show.isOpen,
        open: show.onOpen,
        close: show.onClose,
        toggle: show.onToggle,
        isAny: !!fromDate || !!toDate,

        fromDate, setFromDate,
        toDate, setToDate,

    }
}
export type TAffairFilter = ReturnType<typeof useAffairFilter>;

export interface AffairFilterProps extends Omit<BoxProps, 'filter'> {
    filter: TAffairFilter;
    divider?: boolean;
}

export function AffairFilter({ filter, divider = false, ...rest }: AffairFilterProps) {
    const fromRef = useRef<HTMLInputElement>(null);
    const toRef = useRef<HTMLInputElement>(null);


    return <Collapse in={filter.isOpen} animateOpacity>
        <HStack fontSize='xs'
        >
            <Box p={2} >
                <Box h='0' w='0' overflow='hidden'>
                    <Input type='date' ref={fromRef}
                        value={filter.fromDate ? toSqlDate(filter.fromDate) : ''}
                        onChange={e => filter.setFromDate(new Date(e.target.value))}
                    />
                </Box>
                <ButtonGroup spacing={0} size='xs'>
                    <Button onClick={() => fromRef.current!.showPicker()} colorScheme='secondary'
                        leftIcon={<FaCalendarAlt />} aria-label="Kezdő dátum" borderRightRadius={0}
                        w='100px'
                    >{filter.fromDate ? formatDate(filter.fromDate) : '-'}</Button>
                    <IconButton aria-label="Kezdő dátum kitörlése" icon={<MdClear />} onClick={() => filter.setFromDate(undefined)} borderLeftRadius={0} />
                </ButtonGroup>
            </Box>
            <Box whiteSpace='nowrap' color='InactiveCaptionText'>-tól</Box>
            <Box p={2}>
                <Box h='0' w='0' overflow='hidden'>
                    <Input type='date' ref={toRef}
                        value={filter.toDate ? toSqlDate(filter.toDate) : ''}
                        onChange={e => filter.setToDate(new Date(e.target.value))}
                    />
                </Box>
                <ButtonGroup spacing={0} size='xs'>
                    <Button onClick={() => toRef.current!.showPicker()} colorScheme='secondary'
                        leftIcon={<FaCalendarAlt />} aria-label="Kezdő dátum" borderRightRadius={0}
                        w='100px'
                    >{filter.toDate ? formatDate(filter.toDate) : '-'}</Button>
                    <IconButton aria-label="Kezdő dátum kitörlése" icon={<MdClear />} onClick={() => filter.setToDate(undefined)} borderLeftRadius={0} />
                </ButtonGroup>
            </Box>
            <Box whiteSpace='nowrap' color='InactiveCaptionText' >-ig</Box>
        </HStack>
        {divider && <Divider />}
    </Collapse>
}


/*
export function useAffairFilter() {
    const [isOpen, setIsOpen] = useState(false);
    const [fromDate, setFromDate] = useState<Date | undefined>();
    const fromRef = useRef<HTMLInputElement>(null);

    useModalHost(
        <Modal data-vizv='affair-filter' isOpen={isOpen} onClose={() => setIsOpen(false)}>
            <ModalOverlay />
            <ModalContent bg='cardbg.popup' >
                <ModalHeader >
                    <ModalCloseButton />

                    Filter2+-+</ModalHeader>
                <ModalBody >
                    <FormControl>
                        <FormLabel>Kezdő dátum:</FormLabel>
                        <Box h='0' overflow='hidden'>
                            <Input type='date' ref={fromRef}
                                value={fromDate ? toSqlDate(fromDate) : ''}
                                onChange={e => setFromDate(new Date(e.target.value))}
                            />
                        </Box>
                        <ButtonGroup spacing={0} borderRadius='6px'>
                            <Button onClick={() => fromRef.current!.showPicker()} colorScheme='primary'
                                leftIcon={<FaCalendarAlt />} aria-label="Kezdő dátum"
                                w='140px'
                            >{fromDate ? formatDate(fromDate) : '-'}</Button>
                            <IconButton aria-label="Kezdő dátum kitörlése" icon={<MdClear />} onClick={() => setFromDate(undefined)} />
                        </ButtonGroup>
                        <FormHelperText>{formatDate(fromDate)}</FormHelperText>
                        <FormHelperText>val: "{fromDate ? toSqlDate(fromDate) : ''}"</FormHelperText>
                    </FormControl>
                    <Divider />

                </ModalBody>
            </ModalContent>
        </Modal>
        , [isOpen, fromDate]
    );

    const open = () => {

        setIsOpen(true);
    }

    return {
        open,
        isOpen,
        fromDate
    }
}

*/